export default{
    loadState:function(stateStr:string){
        return '正在：'+stateStr
    },
    search:{
        text:['搜索','取消'],
        scancode:{
            empty:"条形码为空",
            exist:"已经存在条形码",
        }
    },
    ajaxSuccess:"操作成功",
    noAjaxFailMsg:"服务器端无返回错误信息",
    ajaxErrorMsg:{
        unknown:"返回未知错误"
    },
    ajaxErrorInfo:{
        detail:{
            default : "抱歉，页面迷失了方向",
            200:'HTTP 200 – 请求成功',
            201:"HTTP 201 – 请求已被成功接收并处理",
            202:"HTTP 202 – 请求已接收,但尚未处理完毕",
            203:"HTTP 203 – 请求已处理,响应头信息可能不正确",
            204:"HTTP 204 – 请求已处理，但没有返回任何响应内容",
            205:"HTTP 205 – 请求已处理,内容被重置",
            206:"HTTP 206 – 完成了带有Range头的GET请求",
            207:"HTTP 207 – 请求已处理，多状态响应可能需要处理",
            208:"HTTP 208 – 请求无法处理,请检查请求体是否正确",
            226:"HTTP 226 – 关闭数据连接。请求的文件操作已成功",
            300:"HTTP 300 – 请求成功,但结果有多种选择",
            301:"HTTP 301 – 请求成功,但资源被永久转移,响应头中返回了新的请求地址",
            302:"HTTP 302 – 临时重定向",
            303:"HTTP 303 – 使用GET请求来访问的新的地址获取资源",
            304:"HTTP 304 – 请求的资源未被修改",
            307:"HTTP 307 – 请求需要进一步重定向到另一个URL",
            308:"HTTP 308 – 使用原有的地址请求方式来通过新地址获取资源",
            400:"HTTP 400 – 请求出现错误,请检查请求头和请求参数",
            401:"HTTP 401 – 没有提供认证信息,比如请求的时候没有带上token",
            402:"HTTP 402 – 为以后需要所保留的状态码",
            403:"HTTP 403 – 请求的资源不允许访问,即无权限",
            404:"HTTP 404 – 请求的内容不存在",
            405:"HTTP 405 – 不被允许的请求方式或者错误的URL",
            406:"HTTP 406 – 请求的资源不符合要求",
            407:"HTTP 407 – 代理认证信息错误,需要用户认证",
            408:"HTTP 408 – 请求超时",
            409:"HTTP 409 – 请求回导致服务器资源处于不可能或不一致状态",
            410:"HTTP 410 – 请求的资源已永久删除",
            411:"HTTP 411 – 请求头缺少Content-Length",
            412:"HTTP 412 – 请求头文件指出了不满足的先决条件",
            413:"HTTP 413 – 请求体过大",
            414:"HTTP 414 – URL过长,服务器无法处理该请求",
            415:"HTTP 415 – 类型不正确",
            416:"HTTP 416 – 请求的区间无效",
            417:"HTTP 417 – 请求的数据大小超出了服务器的限制",
            418:"HTTP 418 – 爬虫",
            421:"HTTP 421 – 服务不可用",
            422:"HTTP 422 – 请求格式正确,但可能含有语义错误无法响应",
            423:"HTTP 423 – 正在访问的资源已锁定",
            424:"HTTP 424 – 由于之前某个请求发生的错误,导致当前请求失败",
            425:"HTTP 425 – 无法打开数据连接",
            426:"HTTP 426 – 服务器更新协议版本导致的兼容性问题",
            428:"HTTP 428 – 服务器端要求发送条件请求",
            429:"HTTP 429 – 客户端发送了过多请求导致服务器无法响应或限制",
            431:"HTTP 431 – 请求的标头字段存在问题",
            451:"HTTP 451 – 用户代理请求了无法合法提供的资源",
            500:"HTTP 500 – 服务器错误",
            501:"HTTP 501 – 请求还未被发现",
            502:"HTTP 502 – 网关错误",
            503:"HTTP 503 – 服务暂时不可用,可能在更新",
            504:"HTTP 504 – 请求无法在服务器预定时间内得到响应",
            505:"HTTP 505 – 客户端使用的协议版本过高,服务器不支持该版本",
            506:"HTTP 506 – 请求的资源存在多种形式,服务器不确定如何返回正确响应",
            507:"HTTP 507 – 服务器无法存储完成请求所必须的内容",
            508:"HTTP 508 – 对服务器的访问频率太高所以服务器拒绝了请求",
            510:"HTTP 510 – 服务器无法处理请求的HTTP标头扩展时发生的错误",
            511:"HTTP 511 – 服务器可能未正确配置身份验证策略,导致身份验证失败"
        },
        default:{
            200 : "成功",
            400 : "服务器理解不了，请重新输入",
            401 : "您已被限制，请联系系统管理员解除限制",
            403: "服务繁忙，请稍候重试",
            404 : "糟糕，服务器走丢了",
            405 : "糟糕，您已被限制",
            502 : "连接超时，刷新一下",
            default : "抱歉，页面迷失了方向",
        }
    },
    ajaxState:{
        loadingInfo: "正在加载，请稍候",
        loadedError: "数据加载错误",
        noData: "暂无数据",
    },
    converDate:{
        defaultDateFormat: "YYYY/MM/DD",
        errorDateValue: "时间格式错误",
        moneySymbol: "￥",
    },
    template:{
        loadFail:"模板加载失败",
        notExist:"不存在当前模板",
        defaultTitle:{
            add:"新增",
            edit:"修改",
            delete:"删除",
        },
        defaultText:{
            add:"新增",
            edit:"修改",
            delete:"删除",
        }
    },
    timeStampConverErrorMsg:"时间戳转换的数据类型错误：",
    timeStampConverFailMsg:"时间戳转化失败：",
    openPageFail:"打开页面失败: 该页面版本太低，不能打开",
    notPageUrl:"没有找到页面地址请检查",
    noSave:"请先保存再操作",
    noUrl:"不存在url，无法跳转",
    noSelectInfoMsg:"请选择要处理的数据",
    defaultConfirmTitle:"请确认",
    noTel:"没有找到电话",
    saveSuccess:"保存成功",
    formList:{
        column:{
           showTitle:"启用",
           hideTitle:"不启用",
           noData:"暂时没有数据",
           saveBtn:"保存并关闭",
           resetBtn:"恢复默认",
           notDragInner:"请拖动到要拖动的位置元素内",
           notAllHide:"不能全部设置为隐藏列",
           requireNotHidden:"当前字段是必填字段，不能设为隐藏"
        }
    },
    login:{
        name:{
            expire:"登录超时",
            username:"用户名",
            pwd:"密码",
            orgName:"组织名称",
            verifiy:"请输入验证码",
            changeAccount:"切换账号",
            reset:"请重新登录或退出账号。",
            login:"登录"
        },
        strong:"是否强制登录？",
        passwordExpire:"初次登陆或密码超期，是否重置密码？",
        modifyPwd:"密码修改成功",
        oldNewPwd:"新密码不一致",
        username:"用户名必填！",
        pwd:"密码必填！",
        verifiyName:"换一张?",
        autoError:"自动登录失败",
        pwdHasChinesError:"输入的密码含有中文已自动去除",
        qywx:{
            error:"获取企业微信登录码失败"
        },
        wx:{
            error:"获取微信登录码失败"
        },
        scancode:{
            error:"扫码获取token失败"
        },
        expireToken:"用户登录凭证已经超期，请重新登录",
        ajaxReturnToken:"登录接口未返回授权码"
    },
    refreshToken:{
        fail:"刷新token失败，服务器返回数据中 header 不包含 Authorization"
    },
    workflow:{
        flowChartViewer:{
            title:"流程监控"
        },
        noWorkItemId:"没有找到workitemId",
        noInstanceIds:"没有找到instanceIds",
        submit:{
            successMsg:"提交成功",
            defaultMsg:{
                error:"",
                fail:"ajax请求失败，没有返回错误提示",
                success:"没有定义成功的回调不执行任何操作"
            }
        },
        noType:function(workflowType:string){
            return workflowType+'方法不存在';
        }
    },
    config:{
        idUndefined: 	"配置参数中的id 未定义",
        idError: 		"配置参数中的id无法在HTML标签中找到",
    },
    cn:{
        days: ["周日", "周一", "周二", "周三", "周四", "周五", "周六", "周日"],
        daysShort: ["日", "一", "二", "三", "四", "五", "六", "七"],
        daysMin: ["日", "一", "二", "三", "四", "五", "六", "七"],
        months: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
        monthsShort: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
        today: "今天",
        clear: "清除",
        weekStart: 1
    },
    date:{
        format:"YYYY-MM-DD HH:MM:DD",
        rangeFormat:"YYYY-MM-DD",
        selectFormat:"yyyy-mm-dd",
        year:"YYYY",
        monthday:"MM/DD",
        separator:"至",
        applyLabel: "确定",
        cancelLabel: "取消",
        fromLabel: "开始时间",
        toLabel:"结束时间",
        monthNames:["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
        daysOfWeek:["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
        beforeRange:["全部","今天","本周","上周","本月","上月","自定义时间段"],
        afterRange:["全部","今天","本周","下周","本月","下月","自定义时间段"],
    },
    form:{
        addSelectInputError:"增查一体输入框只能有一个",
        organizaSelectError:"组织树结构只能有一个",
    },
    EmptyObject:{
        FormInputData:"无法找到已有组件数据",
        FormInputForm:"无法找到表单"
    },
    ui:{
        nsTree:{
            initConfig:{
                selectModeError: 	"selectMode 参数配置错误 仅可以使用s,single,m,multiple,n,none",
                controlModeError: 	"controlMode 参数配置错误，只能使用form、dialog、none",
                colWidthError: 		"controlColWidth 参数配置错误，必须是1-12之间的正整数",
                emptyData: 			"当前目录树为空，请新建目录",
            },
            dialog:{
                nodeNameLabel: 		"当前目录名称",
                nodeSortLable: 		"排序",
                nodeParentLable: 	"上级目录",
                nodeDeleteNameLable:"删除目录名称",
                nodeAddNameLable: 	"新建目录名称",
                rootName: 		 	"根目录",
                defaultTreeText: 	"未选择目录，新建目录位于根目录",
                defaultMoreTreeText:"未选择目录，默认为最后加载的目录树的根目录",
                defaultMoreNodeText:"你选择了多个节点，当前操作默认为最后一个",
                deleteMoreNodeText: "不支持批量删除",
                deleteEmptyText: 	"请先选择要删除的目录树",
                emptyObject:"请先选择要修改的目录树",
            },
            sortMove:{
                TreeID:"nsTree.sortMove treeID参数错误：",
                SelectItem:"请先选择要修改顺序的节点",
                Direction:"nsTree.sortMove direction参数错误：",
                DirectionUp:"只能是up和down",
                DirectionSuccess:"目录移动成功",
                DirectionError:"目录移动失败，错误信息：",
                DirectionRemindUp:"已经是第一个，无法上移",
                DirectionRemindDown:"已经是最后一个，无法下移",
                modifySuccess:"目录修改成功",
                modifyError:"目录修改失败:",
                modifyErrorRetry:"目录修改失败，请重试或者刷新页面，错误代码:",
            },
            dataConfig:{
                deletetitle:"删除目录项",
                deletenote:"您即将删除该目录，该目录下的子目录也会受到影响。<br> 此次操作将不可恢复，请确认您的选择",
                text:"确认",
                modifytitle:"修改目录项",
                addedtitle:"新增目录项",
            },
            debugerMode:"expandFloor只支持1-3级自动展开",
            expandAllTreeNum:"当前页面有多个目录树组件，需要指定treeID",
            collapseAllTreeNum:"当前页面有多个目录树组件，需要指定treeID",
            MethodSuccess:"目录排序成功",
            MethodError:"目录排序失败，请重试或者刷新页面",
            delParentJson:"目录删除成功",
            deleteFuncError:"目录删除失败，请重试或者刷新页面",
            handlerFunctionSuccess:"目录添加成功",
            handlerFunctionError:"目录添加失败：",
        },
        advancesearch:{
            btn:{
                query:"查询",
                confirm:"确认",
                cancel:"取消",
                empty:"清空",
            },
            infoMsg:"共0个",
            tagMsg:"暂无信息",
            infoMsgA:"请选取配件",
            infoMsgB:"共1个",
            infoMsgC:"请从左侧选取配件",
            infoMsgD:"共",
            infoMsgE:"个",
        },
        formeditor:{
            initSourceList:"已使用",
            setTableAttrOptions:{
                widthNumberBigA:"宽度必须是大于100的数字",
                widthNumberBigB:"宽度数字未填写 必须是大于100的数字",
                widthNumberSmallA:"宽度必须是小于100大于10的数字",
                widthNumberSmallB:"宽度数字未填写 必须是小于100大于10的数字" ,
            },
            initTableAttrPanel:{
                widthLabel:"表格宽度",
                fullwidth:"自适应宽度" ,
                percentwidth: "百分比宽度",
                pxwidth: "像素宽度" ,
                widthLabelJson:"宽度数字",
                widthInputLabel:"列宽度(%)",
                labelInput:"标题",
                typeSelect:"控件类型",
                subdatatext:"文本框",
                subdatadate:"日期框",
                subdataselect:"下拉框",
                readonlyRadio: "是否只读",
                true:"只读",
                false:"可填写",
                formatTypeSelect:"文本格式",
                string:"文本（左对齐）",
                number:"数字（右对齐）",
                money:"货币",
                date:"日期",
                addOptionInput:"添加下拉框选项",
                btnsText:"添加",
                handler:"下拉选项不能为空",
            },
            used:"已使用",
            domGetThWidth:"自动分配",
            editorFormJson:"添加新表单",
        },
        inputSelect:{
            selectPlaneHtml:"出错",
            emptyHtml:"暂无选择项",
            nextItem:"已经是最后一条数据",
            prevItem:"已经是第一条数据",
        },
        nsuiaddsearchinput:{
            currentDataError:"宽度参数错误",
            autoWidthColumnNum:"宽度设置错误，请设置为数字，总和不大于100",
            localDataArr:"返回的数据不是数组",
            localDataArrError:"数据返回错误",
            validationFailure:"验证失败，错误原因：",
            addSuccess:"添加成功",
            saveFailure:"保存格式错误",
            addError:"添加失败，错误原因：",
            addRowData:"未输入",
            nsConfirm:"您填写的数据不完整，是否确认保存？",
            planeTitleHtml:"没有符合条件的数据。您可以直接新建这条数据，使用空格为分隔符",
            undefined:"返回值错误",
        },
        nsuiconfirm:{
            consoleError:"btnsContent属性必须是数组且长度为2",
            consoleErrorchina:"btnsContent中必须是文字",
        },
        nsuicustomsearch:{
            errorCode:"错误代码：",
            errorCodeUnknown:"未知错误",
        },
        nsuiorganizaselect:{
            configlocalDataConfig:"配置参数有误：",
            configurl:"配置参数请求链接有误：",
            configdata:"配置参数检索条件有误：",
            rowHandlerEdit:"编辑",
            rowHandlerDel:"删除",
            rowHandlerAdd:"添加",
            tbodyHtmlEmpty:"没有符合条件的数据",
            totalPageSpanA:"共",
            totalPageSpanB:"条",
        },
        nsuipersonselect:{
            configObjError:"人员选择器配置参数错误",
            consolelog:"已经关了",
            getErrorHtml:"不能获取人员信息",
            getHistoryPlaneHtmlA:"您还没有保存过历史记录，系统会自动为您保存最近的十条记录",
            getHistoryPlaneHtmlB:"最多保存10条历史记录，当前共",
            getHistoryPlaneHtmlC:"条",
            histryPersonArr:"未识别",
            WidthError:"宽度参数错误",
            autoWidthColumnNum:"宽度设置错误，请设置为数字，总和不大于100",
            resultPersonArr:"您还没有选择人员",
            inputMaskHtmlspan:"共",
            inputMaskHtmlspanA:"人",
            stateEmpty:"没有数据",
            returnValuespanA:"有效数量是",
            returnValuespanB:"到",
            returnValuespanC:"最大数量是",
            returnValuespanD:"个",
            arraylength:"共：",
            configurationParameter:"配置参数错误",
            confirmHandlerError:"confirmHandler参数错误，必须是function",
        },
        nsuiprojectselect:{
            getPlaneHtmlSpanA:"左右翻页，上下移动，空格选择，回车确认",
            getPlaneHtmlSpanB:"单击选择，双击操作，箭头批量操作",
            getTitleHtmlClassify:"全部分类 ",
            getTitleHtmlSelectItem: "选择项目",
            getTitleHtmlPlaceholderStr:"名称 / 简拼",
            getClassListAjaxNoClassify:"无分类信息",
            getListHtmlSearch:"搜索结果为空",
            refreshList:"已选中，不能多次选择",
            arrAddHandler:"请先选择项目",
            getListAjax:" 无法找到对应数据",
            getListErrorA:"没有获取到项目信息，返回项目数量为 0",
            getListErrorB:"参数错误：（listAjax.dataSrc：",
            getListErrorC:"listAjax请求失败：",
            maximumItem:"已经到达最大选择条数",
        },
        nsuiquicktyping:{
            initContainerA:"快速输入组件 id:",
            initContainerB:"的数量只能是1个，现在有",
            initContainerC:"个",
            isIndex:"projectField中，只能设置一个字段为isIndex，已经设置为",
            isID:"projectField中，只能设置一个字段为isID，已经设置为",
            isName:"projectField中，只能设置一个字段为isName，已经设置为",
            consoleinfoA:"projectTableWidth已经被修改,原值：",
            consoleinfoB:" 现值：",
            projectSearchField:"projectField中没有定义搜索字段",
            titleField:"projectField中没有定义标题字段",
            projectIndexField:"projectField中没有定义isIndex，必须定义",
            projectIdField:"projectField中没有定义isID, 必须定义",
            addSelectError:"输入值找不到符合条件选项",
            addNumber:"请输入大于0的数字",
            confirmResult:"inputOrder设置的",
            confirmResultObject:"对象未定义",
            confirmResultString:".type属性未定义",
        },
        nsuitreeplane:{
            getCheckIDs:"的数据不存在",
        },
        nsuisyspersondata:{
            personAjax:"出错",
            personAttributeWidth:"宽度参数错误",
            personAttributeHundred:"宽度设置错误，请设置为数字，总和不大于100",
        },
        ztree:{
            matchConfig:"容器id找不到",
            matchConfigUrl:"请求链接必须传正确的url",
            getTreeAjaxError:"返回数据有误",
            getTreeAjaxSearchError:"ajax查询数据出错",
        },
        nsuiformmanager:{
            title:"表单用户配置",
            params:{
                column:"列宽（1-12）",
                height:"高度",
                hidden:"是否隐藏",
                oldLabel:"原标题",
                order:"排序",
                newLabel:"新标题"
            }
        },
        nsuitablemanager:{
            title:"表格用户配置",
            tabname:{
                before:"前固定列",
                after:"后固定列",
                hidden:"隐藏列",
                auto:"自动分组列",
                all:"全部",
                short:"快捷配置",
                manager:"表格TAB管理"
            }
        },
        nsuiimportDialog:{
            stepFirst:{
                linkUrl:"点击下载导入数据模板",
                information:{
                    title:"将要导入的数据填充到数据导入模板文件中 注意事项：",
                    warning:{
                        title:"注意事项：",
                        warnArray:["1）模板中的表头不可更改，表头行不可删除；","2）除必填的列以外，不需要的列可以删除；","3）单次导入的数据不超过1000条。"]
                    }
                }
            },
            stepSecond:{
                linkUrl:"点击下载导入数据模板",
                information:{
                    title:"将要导入的数据填充到数据导入模板文件中 注意事项：",
                    warning:{
                        title:"注意事项：",
                        warnArray:["1）模板中的表头不可更改，表头行不可删除；","2）除必填的列以外，不需要的列可以删除；","3）单次导入的数据不超过1000条。"]
                    }
                }
            },
            stepThird:{
                linkUrl:"点击下载导入数据模板",
                information:{
                    title:"将要导入的数据填充到数据导入模板文件中",
                    warning:{
                        title:"注意事项：",
                        warnArray:["1）模板中的表头不可更改，表头行不可删除；","2）除必填的列以外，不需要的列可以删除；","3）单次导入的数据不超过1000条。"]
                    }
                }
            }
        },
        htmlInput:{
            tagError:"标签不能互相套嵌",
        },
        pagelast:"已经是最后一页了",
        pageFirst:"已经是第一页了",
        linelast:"已经是最后一行",
        lineFirst:"已经是第一行",
        loading:"正在加载...",
        setDefaultSuccess:"确定",
        setDefaultCancel:"取消",
        confirm:"确认",
        length:"等",
        required:"必填",
        all:"全部",
    },
    netstarDialog:{
        upload:{
            dictDefaultMessage:"选择上传",
            dictMaxFilesExceeded:"您一次最多只能上传{{maxFiles}}个文件",
            formatNotSupported:  "不支持上传的格式",
            dictResponseError:   "文件上传失败",
            nameTypeNotMatch:    "文件名和类型不匹配",
            maxFiles:["您一次最多只能上传","个文件"]
        },
        nsalert:{
            tableIDIsUndefined:"表格ID未定义",
            tableDataSourceIsUndefined:"表格数据来源未定义",
        },
        title:{
            operation:"操作",
        },
        content:{
            unsavedDataIsSava:"您有未保存的数据,是否保存?",
        },
        btns:{
            savaIsNoSava:["保存","不保存"],
            cancelNoCancel:["取消","关闭"],
        }
    },
    datatable:{
        btns:{
            open:"打开",
            add:"新增",
            edit:"修改",
            del:"删除",
        },
        label:{
            export:"导出",
            exportCSVDocuments:"导出所有CSV文档",
            exportVisableCSVDocuments:"导出当前CSV文档",
            exportCsvSelectedDocuments:"导出CSV选中值",
            exportCsvUnSelectedDocuments:"导出CSV不选中值",
            exportExcelDocuments:"导出所有Excel文档",
            exportVisableDocuments:"导出当前Excel文档",
            exportSelectedDocuments:"导出Excel选中值",
            exportUnSelectedDocuments:"导出Excel不选中值",
            selectDisplayDataColumn:"选择显示数据列",
            showAll:"全部显示",
            selectColumn:"选择列",
            emergency:"急",
            backspace:"退",
            reminder:"催",
            exceed:"超",
            obsolete:"废",
            outsource:"分",
            quality:"质",
            recheck:"复",
            notes:"注",
            extraurgent:"特",
            sampling:"取",
            sampled:"采",
        },
        fillStatus:{
            optional:"选填",
            required:"必填",
            whole:"全部",
        },
        pageStatus:{
            noData:"没有数据",
            inLoad:"加载中...",
            inQuery:"查询中...",
            eachPageStrip:"每页 _MENU_ 条",
            notFound:"没有找到记录",
            pageNumber:"第 _PAGE_ 页 ( 共 _PAGES_ 页 )",
            pageNumberWithMax: "第 _PAGE_ 页 ( 共 _PAGES_ 页 _MAX_ 行)",
            noRecord:"无记录",
            recordFiltering:"(从 _MAX_ 条记录过滤)",
            serialNumber:"序号",
        },
        nsalert:{
            uncheckLineNeed:"没有勾选需要获取的行",
             verifyDataFormat:"请核实传输的数据格式",
             uncheckLine:"请先选中要获取的行",
             uncheckLineOne:"请先至少选中一行",
             uncheckLineOneDel:"请先选中要删除的行",
             alreadyTop :"已经到顶部了",
             inEnd:"已经到底部了",

        }
    },
    messager:{
        messageContent:"消息内容",
        prompt:"提示",
        determine:"确定",
    },
    common:{
        returnError: 	"服务器返回出错",
        networkError:  	"网络请求错误",
        dialog:{
            showMore:"展开更多",
            closeMore:"关闭更多"
        },
        commonconfig:{
            label:{
                fileArea:"文件区域",
                province:"省",
                city:"市",
                area:"区",
            },
            nsalert:{
                checkDataFormat:"请检查数据格式是否合法",
                success:"操作成功"
            },
            Verification:{
                required:"必填",
                date:" 年-月-日",
                url:" 有效网址",
                number:" 数字",
                positiveInteger:"正整数",
                integer:"整数",
                minlength:["最少","个字"],
                precision:["小数位数","位"],
                maxlength:["最多","个字"],
                min:["不小于","的数字"],
                max:[" 不大于","的数字"],
                range:[" 数字 ","到"],
                ismobile:" 默认手机号11位",
                postalcode:"请输入邮政编码",
                year:"请输入四位年份",
                month:"请输入月份",
                Icd:"请输入身份证号码",
                bankno:"请输入银行卡号",
                select:"请选择",
            }
        },
        fromplane:{
            tableTypeDefinition:"表格类型定义错误",
            formCannotFound:"无法找到表单",
            dataCannotFound:"无法找到已有组件数据",
            errorReturn:"返回值错误",
            validationFailure:"验证失败，请核实填写的内容",
            
        },
        mainmenu:{
            menuError:"菜单加载出错",
            homepage:"首页",
            loadingInfo: "正在加载，请稍候",
            loadedError: "数据加载错误",
            noData: "暂无数据",
            loadingInfoClass:"menu-loading",
            loadedErrorClass:"menu-loadederror",
            noDataClass:"menu-nodata",
        },
        nsalert:{
            determine:"确定",
            login:"登录",
            cancel:"取消",
            success:"成功",
            complete:"完成",
            fail:"失败",
            error:"错误",
            deyk:"有误",
            remind:"提醒",
            warning:"警告",
            prompt:"提示",
            unable:"无法",
            prohibit:"禁止",
        },
        nsframe:{
            SaveOperation:"您有未保存的操作，是否保存？",
            historicalRecord:"没有更多的历史记录了",
            untreated:"未处理的情况",
        },
        nsmultiselect:{
            search:"搜索...",
            selected:"请先选中需要排序的值",
            systemHintop:"系统提示,已移到最顶端了！",
            systemHinBottom:"系统提示,已移到最底端了！",
        },
        provinceselect:{
            noMessage:"暂无信息",
        },
        screen:{
            fullScreen:"已进入全屏，<br>按下ESC或者点击此按钮退出全屏",
            noFullScreen:"您的浏览器不支持此方法，<br>您可以按下F11进入全屏<br>也可以更换为Google Chrome或者360浏览器、猎豹浏览器等推荐浏览器",
        },
        validate:{
            ismobileError:"电话号码格式有误!",
            postcodeError:"邮政编码格式有误!",
            yearSection:"请输入正确年份,1900-2099!",
            monthSection:"请输入正确月份,1-12",
            IcdLegitimate:"请输入合法身份证号码!",
            banknoLegitimate:"请输入正确的银行卡号!",
            required:"必填",
            optional:"选填",
            select:"请选择",
            wrongful:"不合法!",
            remote: "验证未通过",
            email: "电子邮件",
            date: "有效日期",
            dateISO: "有效日期 (YYYY-MM-DD)",
            url:" 有效网址",
            number: "有效数字",
            positiveInteger: "正整数",
            integer: "整数",
            digits: "只能是数字",
            creditcard: "有效的信用卡号码",
            equalTo: "两次输入不同",
            extension: "后缀无效",
            minlength:"最少 {0} 个字符",
            maxlength:"最多 {0} 个字符",
            rangelength:"长度在 {0} 到 {1} 之间",
            range:"范围在 {0} 到 {1} 之间",
            max:"不大于 {0} 的数值",
            min:"不小于 {0} 的数值",
        },
        nscomponent:{
            placeHolder:{
                undefined:"nsComponent.getPlaceHolder 参数config未定义",
                configRules:"规则参数错误,只能包含小写字母,数字,空格,[],逗号",
                returnSelect:"请选择",
                select2: "必填",
                dateISO: "年/月/日",
                url: "有效网址",
                number: "数字",
                positiveInteger: "正整数",
                integer: "整数",
                ismobile: "11位手机号码",
                postalcode:"邮政编码",
                year:"四位年份",
                month:"月份",
                icd:"身份证号",
                bankno:"银行卡号",
                minlength:"最少",
                font:"字",
                precision:"小数",
                position:"位",
                maxlength: "最多",
                min:"最小",
                max:"最大",
                range:"到",
                equalTo:"",
                tablename:"只能输入字母下划线",
                negative:"负数",
                nonnegativeInteger:"非负整数",
                nonnegative:"非负数",
                unrecognizedRule:"不能识别的规则：",
                rangelength:"长度在",
                isphone:"固定电话",
            },
            part:{
                returnValueEmpty:"函数的返回值是值是undefined，已经自动转化为空",
                invalidDate:"value格式不合法，格式应当为",
                formatType:"是未定义的文本格式化参数，支持的参数包括string/number/date/money",
                inputHtmlFileArea:"文件区域",
                province:"省",
                city:"市",
                area:"区",
                currentProvalProvince:"省份",
                radioAjaxError:"radio组件ajax数据调用出错",
                checkboxAjaxError:"checkbox组件ajax数据调用出错",
                selectajaxError:"select组件ajax数据调用出错",
                selectajaxErrorB:"select2组件ajax数据调用出错",
                subdataArray:"config.subdata必须是数组",
                daterangeStart:"至",
                converSelect:"请检查数据格式是否合法",
            },
            daterangepicker:{
                today:"今天",
                yesterday:"昨天",
                sevendays:"最近7天",
                thirtydays:"最近30天",
                week:"本周",
                lastweek:"上周",
                month:"本月",
                lastmonth:"上月",
                applyLabel:"确认",
                cancelLabel: "取消",
                fromLabel: "从",
                toLabel: "到",
                customRangeLabel: "选择日期区间",
                defaultDateRange:"默认日期区间",
                localeformat: "YYYY/MM/DD",
                default:"默认：",
            },
            select2BoxIt:{
                dictDefaultMessage:"选择上传",
                dictMaxFilesExceeded:"您一次最多只能上传{{maxFiles}}个文件",
                dictResponseError:"文件上传失败",
                dictInvalidFileType:"文件名和类型不匹配",
                isAllowFilesA:"您一次最多只能上传",
                isAllowFilesB:	"个文件",
                receiveFile:"返回数据格式不对",
                isQuery:"未找到匹配值",
            },
            setDefault:{
                element:"element配置参数不合法, 支持类型是label title hr br",
                uploadSingle:"上传组件配置参数不合法,必须配置url链接",
                columnRangeA:"column的取值范围是0-12，当前值",
                columnRangeB:",已经修改为默认值",
                appointUrl:"已经指定url，subdata被自动忽略",
                configSubdata:"config.subdata参数不合法",
            },
            edit:{
                formParameter:" 无法找到表单的配置参数",
                componentParameter:" 无法找到组件的配置参数",
            },
            setValue:{
                notfoundformConfiguration:" 表单配置找不到",
                notfoundComponent:"组件找不到",
                
            }
        }
    },
    default:{
        dateFormat:"yyyy-mm-dd", 			//日期默认格式
        momentDate:"YYYY-MM-DD",
        momentDataTime:"YYYY-MM-DD HH:mm:ss",
        dateTimeFormat:"yyyy-mm-dd hh:ii", 	//日期时间默认格式
        weekStart:1, 						//面板显示从周几开始，周日是0，周一是1
        language:"cn", 						//英文为en
        empty:"无",
    },
    requestAjax:{
        fail:"请求失败",
        success:"请求成功",
        error:"请求错误"
    }
}